export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9820.d3e3e980.jpg";